import React, { useRef } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";
import html2canvas from "html2canvas";

interface BarChartProps {
  chartName: string;
  data: {
    name: string;
    captured_co2: number;
    generated_o2: number;
  }[];
}

const BarChartComponent: React.FC<BarChartProps> = ({ chartName, data }) => {
  const chartRef = useRef<HTMLDivElement>(null);

  const saveChartAsImage = async () => {
    if (!chartRef.current) return;

    const element = chartRef.current;

    const canvas = await html2canvas(element, {
      // ให้ html2canvas เรนเดอร์เต็มความกว้าง-สูงจริงของ element
      scrollX: 0,
      scrollY: 0,
      width: element.scrollWidth,
      height: element.scrollHeight,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
      scale: 2, // ให้ภาพคมขึ้นด้วย (2x)
    });

    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = "bar-chart.png";
    link.click();
  };

  return (
    <div className="p-5 flex flex-col w-full px-1 lg:px-4">
      <div className="bg-white p-4 rounded-lg shadow-lg">
        <h2 className="font-semibold text-center mb-2">{chartName}</h2>

        <div className="overflow-x-auto no-scrollbar">
          <div
            ref={chartRef}
            className={`${
              data.length > 50 ? "min-w-[1500px]" : "min-w-[900px]"
            } w-full h-[250px] text-xs`}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data}
                margin={{ top: 10, right: 20, left: 0, bottom: 10 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar
                  dataKey="captured_co2"
                  fill="#4EA72E"
                  name="Captured CO2"
                />
                <Bar
                  dataKey="generated_o2"
                  fill="#E97132"
                  name="Generated O2"
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="flex items-start w-full">
        <button
          onClick={saveChartAsImage}
          className="mt-4 bg-green text-sm text-white px-4 py-2 rounded-lg shadow-md hover:bg-green/50"
        >
          Download Image
        </button>
      </div>
    </div>
  );
};

export default BarChartComponent;
